import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-form-text-link',
  templateUrl: './text-link.component.html',
})
export class TextLinkComponent implements OnInit {
  @Input() textLink

  constructor() {
  }

  ngOnInit() {
  }
}
